import {PagedList} from "../../../models/paged-list";
import instance from "../../index";
import {useEffect, useState} from "react";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import {ClientDashboardDto} from "../../../models/clientDashboardDto";
import {BaseResponse} from "../../../models/base-response";
import {ClientDashboardFilter} from "../../../filters/client-dashboard-filter";

export const useDashboardService = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();

    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    async function getClientDashboardPerPeriod(clientId: string, filter?: ClientDashboardFilter): Promise<ClientDashboardDto> {
        setLoading(true);
        try {
            const response = await instance.get<BaseResponse<ClientDashboardDto>>(`/v1/backoffice/dashboard/client/${clientId}`, {
                params: filter
            });
            return response.data.data;
        } finally {
            setLoading(false);
        }
    }

    return {
        getClientDashboardPerPeriod
    }
};